import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BASE_URL_ADMIN } from "../constants/constant";
import axios from "axios";
import Sidebar from "../sidebar/sidebar";
import TopBar from "../Navbar/Pages/Topbar";

const EditFamilyPackage = () => {
  const { packageId } = useParams();
  const navigate = useNavigate();

  const [adminId, setAdminId] = useState(null);
  const [formData, setFormData] = useState({
    packagename: "",
    destination: "",
    adult_perheadprice: "",
    child_perheadprice: "",
    roomamount: "",
    advancepyment: "",
    packageimage: null,
  });

  useEffect(() => {
    const storedAdminId = sessionStorage.getItem("admin_id");
    if (!storedAdminId) {
      navigate("/adminlogin");
      return;
    }
    setAdminId(storedAdminId);

    axios
      .post(`${BASE_URL_ADMIN}get_single_family_package.php`, {
        package_id: packageId,
      })
      .then((res) => {
        if (res.data.success && res.data.data) {
          const data = res.data.data;
          setFormData({
            packagename: data.packagename,
            destination: data.destination,
            adult_perheadprice: data.adult_perheadprice,
            child_perheadprice: data.child_perheadprice,
            roomamount: data.roomamount,
            advancepyment: data.advance_payment_percentage,
            packageimage: null,
          });
        } else {
          alert("Package not found");
          navigate("/adminviewfamilypackage_booking");
        }
      })
      .catch((err) => {
        console.error("Error fetching package:", err);
        alert("Error loading package.");
      });
  }, [packageId, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData((prev) => ({ ...prev, packageimage: file }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      if (key === "packageimage" && value) {
        data.append("packageimage", value);
      } else {
        data.append(key, value);
      }
    });

    data.append("package_id", packageId);
    data.append("updated_by", adminId);

    axios
      .post(`${BASE_URL_ADMIN}update_family_package.php`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        if (res.data.success) {
          alert("Package updated successfully!");
          navigate("/adminviewfamilypackage_booking");
        } else {
          alert("Update failed: " + res.data.message);
        }
      })
      .catch((err) => {
        console.error("Update error:", err);
        alert("Something went wrong while updating.");
      });
  };

  return (
    <div className="container-fluid">
      <TopBar />
      <div className="row">
        <Sidebar />
        <div className="col-md-9 offset-md-2 p-4">
          <h2 className="text-center mb-4">Family Tour Package Update</h2>
          <form
            onSubmit={handleSubmit}
            className="p-4 border rounded shadow bg-white"
          >
            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">Package Name</label>
                <input
                  type="text"
                  name="packagename"
                  className="form-control"
                  value={formData.packagename}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Destination</label>
                <input
                  type="text"
                  name="destination"
                  className="form-control"
                  value={formData.destination}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">Adult Perhead Price</label>
                <input
                  type="number"
                  name="adult_perheadprice"
                  className="form-control"
                  value={formData.adult_perheadprice}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Child Perhead Price</label>
                <input
                  type="number"
                  name="child_perheadprice"
                  className="form-control"
                  value={formData.child_perheadprice}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">Room Rent</label>
                <input
                  type="number"
                  name="roomamount"
                  className="form-control"
                  value={formData.roomamount}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Advance Payment Percentage</label>
                <input
                  type="number"
                  name="advancepyment"
                  className="form-control"
                  value={formData.advancepyment}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label">Upload New Image</label>
              <input
                type="file"
                name="packageimage"
                className="form-control"
                accept="image/*"
                onChange={handleFileChange}
              />
            </div>

            <div className="text-center mt-4">
              <button
                type="submit"
                style={{
                  backgroundColor: "#f19b23",
                  padding: "10px 25px",
                  borderRadius: "5px",
                  color: "#fff",
                  border: "none",
                }}
              >
                Update Package
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditFamilyPackage;
